<template>
    <f-dialog
        v-model       = "value"
        :show-header  = "false"
        :full-screen  = "false"
        :hide-actions = "false"
        :width        = "500"
        @store        = "onStore"
        @cancel       = "onClose"
    >
        <template v-slot:content>
            <v-row dense class="mt-1">
                <v-col>
                    <v-text-field
                        :label         = "$t('inb.overview.customer.dialog.mailbox')"
                        v-model        = "data.mailbox"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />

                    <v-textarea
                        :label         = "$t('inb.overview.customer.dialog.sender')"
                        v-model        = "data.sender"
                        rows           = "10"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        hide-details   = "true"
                        flat
                        no-resize
                    />
                </v-col>
            </v-row>
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog";
import Inb from "@/modules/inb/service/Inb";

export default {
    name: "DInboxCustomer",
    components: {
        FDialog
    },

    props: {
        value: {

        },

        customerId: {

        }
    },

    data: () => ({
        data: {
            mailbox: null,
            sender : null
        },
    }),

    watch: {
        value () {
            if (this.value) {
                this.load ();
            }
        }
    },

    methods: {
        load () {
            console.log("load customer")
            Inb.customer.read(this, this.customerId, (data) => {
                this.setData(data);
            }) ;
        },

        onStore () {
            const sender = this.data.sender.split (String.fromCharCode(10))
            Inb.customer.update(this, {
                id     : this.customerId,
                mailbox: this.data.mailbox,
                sender : sender
            },(data) => {
                this.setData(data);
            })
        },

        onClose () {
            this.$emit("input", false);
        },

        setData (data) {
            this.data.mailbox = data.mailbox;
            let sender = "";
            data.sender.forEach (s => {
                sender += s + String.fromCharCode(10);
            });

            this.data.sender = sender;
        }
    }
}

</script>

<style scoped>

</style>